export default {
  parseContactsData: function (contacts) {
    if (!contacts || !Array.isArray(contacts)) {
      return []
    }

    const now = Date.now();

    const contactsRegisteredByChekt = contacts.filter((contact) => {
      return (contact.registered_by_partner ?? 'chekt') === 'chekt';
    });

    return contactsRegisteredByChekt.map(contact => {
      const expireTime = this.calculateExpireTime(contact);
      const isExpired = this.isContactVerifyExpired(now, expireTime, contact.verify_status);

      return {
        ...contact,
        is_expired: isExpired
      }
    })
  },

  calculateExpireTime: function (contact) {
    const duration = contact.verify_expire_duration || 0;
    const requestTime = contact.verify_request_time || 0;
    return (duration + requestTime) * 1000;
  },

  isContactVerifyExpired: function (now, expireTime, verifyStatus) {
    return now > expireTime && verifyStatus === 0
  }
}